// "12 Sep 2026" from a YYYY-MM-DD string, read as a local date
export function formatShortDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}

// "15 Jan 2027" from either YYYY-MM-DD or a loose date like "Feb 10 2026"; falls back to the input
export function formatAnyDate(value: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return formatShortDate(value);
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}
